import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "app/store";
import App from "App";
import "index.css";
import fixViewPortHeight from "helpers/fixViewPortHeight";
import { getConnectedAsync } from "adminPanel/user/userSlice";
import axios from "axios";
import CenteredCircularProgress from "components/general/CenteredCircularProgress";
import ErrorFallback from "components/general/ErrorFallback";
import { OrganizationsSettingsAsync } from "adminPanel/settings/organizationSettings";
import * as Sentry from "@sentry/react";
import { ErrorBoundary } from "@sentry/react";
import { getEmployeeSettingAsync } from "amnPos/slices/EmployeeSettingSlice";
import { getPosSettingAsync } from "amnPos/slices/PosSettingSlice";

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracePropagationTargets: ["localhost:5095/api", /^https?:\/\/.*\/api/],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
  });
}

fixViewPortHeight();

if (import.meta.env.DEV) axios.defaults.withCredentials = true;

const isInternalConsoleEnabled =
  import.meta.env.VITE_INTERNAL_CONSOLE_ENABLED === "true";
const isInternalConsoleRoute =
  isInternalConsoleEnabled &&
  window.location.pathname.startsWith("/internal");

if (!isInternalConsoleRoute) {
  await store.dispatch(getConnectedAsync());
  await store.dispatch(OrganizationsSettingsAsync());

  const state = store.getState();
  if (state.user.isCasher) {
    await store.dispatch(getEmployeeSettingAsync());
  }

  const posId = localStorage.getItem("posId");
  if (posId) {
    await store.dispatch(getPosSettingAsync(posId));
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <ErrorBoundary fallback={<ErrorFallback />}>
    <Provider store={store}>
      <PersistGate loading={<CenteredCircularProgress />} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </ErrorBoundary>
  // </React.StrictMode>
);
